import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/no-saved-filters.png")